module.exports = __webpack_public_path__ + "img/cu.09f1c831.svg";